import $ from 'jquery'
//accordion
$(document).ready(function() {
	if (!$('.accordion-title').length) {
		return
	}

	$('.accordion-title').on('click', function(e) {
		e.preventDefault()
		$(this).toggleClass('active')
	})

	const hash = $(location).attr('hash')
	if (hash && hash != '#content-anchor') {
		const $target = $(hash)
		const $accordion = $target.closest('.accordion-wrapper')
		if ($accordion.length) {
			$accordion.find('.accordion-title').trigger('click')
			setTimeout(function() {
				$('html, body').animate({ scrollTop: $target.offset().top }, 500)
			}, 500)
		}
	}
})
